import styled from "styled-components";

export const StyledFormContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  maxWidth: 1800,
  "& form": {
    width: "100%",
  },
  margin: "auto",
  marginBottom: 6,
  
});
